module.exports = __webpack_public_path__ + "static/power-687ef0ce7afa0d6169b564e453b63cf7.jpg";